import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-199">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-padel-surface/95 backdrop-blur-md border-t border-padel-muted shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" data-id="element-200">
          <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-6" data-id="element-201">
            <div className="text-center sm:text-left hidden sm:block" data-id="element-202">
              <p className="text-sm text-gray-300 font-medium" data-id="element-203">
                El sistema completo para profes de pádel
              </p>
              <p className="text-padel-lime font-bold text-lg leading-none mt-1" data-id="element-204">
                MÉTODO PRO-PÁDEL 360
              </p>
            </div>
            <a href="https://stock-digital-shop.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-padel-lime hover:bg-padel-limeHover text-padel-dark font-display font-bold text-lg sm:text-xl px-8 py-3 sm:py-4 rounded-lg flex items-center justify-center gap-2 transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(197,255,61,0.3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-205">
              QUIERO MI PACK AHORA
              <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-206" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}